<div class="container-fluid p-3 min-vh-100 d-flex flex-column gap-3">

  <!-- Action Toolbar Header Section -->
  <header class="d-flex align-items-center gap-2 mt-2 mb-2 p-3 rounded-4 border shadow-sm bg-body-tertiary">
    <button type="button"
      class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm text-body fw-semibold transition-base"
      (click)="goBack()">
      <i class="fa-solid fa-arrow-left font-xs"></i>
      <span>Back</span>
    </button>
  </header>

  <!-- Premium File Registry Workspace Card Wrapper Box -->
  <div class="card border shadow-sm rounded-4 overflow-hidden bg-body w-100 mb-4">
    <div class="table-responsive-container m-0">
      <table class="table table-hover align-middle mb-0 text-nowrap table-dense">

        <!-- Table Header Matrix Structures -->
        <thead class="table-light text-body-secondary font-monospace small text-uppercase tracking-wider border-bottom">
          <tr>
            <th scope="col" class="ps-4 py-3" width="70">SrNo</th>
            <th scope="col" class="py-3" style="min-width: 200px;">File Name</th>
            <th scope="col" class="py-3" style="min-width: 130px;">Redeemed Status</th>
            <th scope="col" class="py-3" style="min-width: 140px;">Redeemed Type</th>
            <th scope="col" class="py-3" style="min-width: 160px;">Redeemed Date Type</th>
            <th scope="col" class="py-3" style="min-width: 140px;">Start Date</th>
            <th scope="col" class="py-3" style="min-width: 140px;">End Date</th>
            <th scope="col" class="py-3 text-center" width="130">Export Status</th>
            <th scope="col" class="pe-4 py-3 text-end" width="100">Action</th>
          </tr>
        </thead>

        <!-- Table Body Row Interpolations Loops -->
        <tbody class="small text-body">
          @for (data of dataList() | paginate: {
          itemsPerPage: pageSize(),
          currentPage: page(),
          totalItems: allTotal()
          }; track $index; let i = $index) {
          <tr class="transition-base">
            <td class="ps-4 font-monospace fw-medium text-body-secondary">{{ data.srNo }}</td>
            <td class="fw-bold text-body text-truncate max-w-250" [title]="data.downloadFileName">{{
              data.downloadFileName }}</td>
            <td>
              <span
                class="badge bg-body-secondary text-body-secondary border border-secondary-subtle px-2.5 py-1.5 font-monospace tracking-wide font-xs shadow-sm">
                {{ data.redeemedStatus || '-' }}
              </span>
            </td>
            <td class="text-uppercase font-xs font-monospace text-body-secondary">{{ data.redeemedItemType || '-' }}
            </td>
            <td class="text-uppercase font-xs text-body-secondary">{{ data.redeemedDateType || '-' }}</td>
            <td class="font-monospace text-body-secondary font-xs">{{ data.startDate ? (data.startDate | dateFormat) :
              '-' }}</td>
            <td class="font-monospace text-body-secondary font-xs">{{ data.endDate ? (data.endDate | dateFormat) : '-'
              }}</td>

            <!-- Refactored Clean Semantic Theme-Adaptive Badges -->
            <td class="text-center">
              <span
                class="badge rounded-pill px-2.5 py-1.5 text-uppercase font-monospace tracking-wide font-xs fw-semibold"
                [ngClass]="{
                        'bg-success-subtle text-success-emphasis border border-success-subtle': data.status === 'READY',
                        'bg-danger-subtle text-danger-emphasis border border-danger-subtle': data.status === 'FAILED',
                        'bg-primary-subtle text-primary-emphasis border border-primary-subtle': data.status === 'Processing' || data.status === 'PENDING'
                      }">
                {{ data.status }}
              </span>
            </td>

            <!-- Circular Adaptive Theme-Friendly Icon Download Button Formats -->
            <td class="pe-4 text-end">
              <button type="button"
                class="btn btn-sm btn-icon btn-success rounded-circle shadow-sm transition-base d-inline-flex align-items-center justify-content-center"
                title="Download Document" (click)="downloadFile(data.downloadFileName, i)"
                [disabled]="data.status !== 'READY' || isDownloadBtnLoading()[i]">
                @if (isDownloadBtnLoading()[i]) {
                <span class="spinner-border micro-spinner m-0" role="status" aria-hidden="true"></span>
                } @else {
                <i class="fa-solid fa-download font-xs text-white"></i>
                }
              </button>
            </td>

          </tr>
          } @empty {
          <!-- Empty Data Grid Operational Fallback View Placeholder -->
          <tr>
            <td colspan="9" class="text-center py-5 text-body-secondary font-monospace">
              <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
                <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
                <span class="tracking-wider"> No downloadable files available.</span>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Custom styled Pagination Layout Element -->
  <div class="d-flex justify-content-center mt-3">
    <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
      class="dashboard-pagination" (pageChange)="handlePageChange($event)">
    </pagination-controls>
  </div>

</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}